import { useState, useEffect } from "react";

import { TIME_INTERVALS } from "@/shared/config";

export const useCountdown = (targetDate: string) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown: number) => {
  // calculate time left
  const days = Math.floor(countDown / TIME_INTERVALS.DAY);
  const hours = Math.floor(
    (countDown % TIME_INTERVALS.DAY) / TIME_INTERVALS.HOUR,
  );
  const minutes = Math.floor(
    (countDown % TIME_INTERVALS.HOUR) / TIME_INTERVALS.MINUTE,
  );
  const seconds = Math.floor(
    (countDown % TIME_INTERVALS.MINUTE) / TIME_INTERVALS.SECOND,
  );

  const isFinished = days + hours + minutes + seconds <= 0;

  return { days, hours, minutes, seconds, isFinished };
};
